export const STUDENT_PORTAL_STORAGE_KEYS = {
  talabaId: 'student_portal_talaba_id',
  passport: 'student_portal_passport',
  image: 'student_portal_rasm',
  testBoshqaruvId: 'student_portal_test_boshqaruv_id',
  token: 'student_portal_token'
};

const isBrowser = () => typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

export const setStudentPortalContext = () => {};

export const readStudentPortalContext = () => {
  return {
    talabaId: '',
    passport: '',
    image: '',
    testBoshqaruvId: '',
    token: ''
  };
};

export const clearStudentPortalContext = () => {
  if (!isBrowser()) {
    return;
  }

  Object.values(STUDENT_PORTAL_STORAGE_KEYS).forEach(key => {
    window.localStorage.removeItem(key);
  });

  ['test_boshqaruv_id', 'pasport', 'rasm', 'student_token'].forEach(key => {
    window.localStorage.removeItem(key);
  });
};
